module.exports = __webpack_public_path__ + "img/契约系统1.8155c307.png";